import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Box } from '@mui/material';
import { AutoLink, ClassicEditor, Essentials, Link, Paragraph } from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { saveNotes } from '../../store/actions/survey';
import Button from '../FormComponents/Button';
import Modal from '../Modal/Modal';
import ToastMessage from '../ToastMessage/ToastMessage';
import './SurveyForm.scss';

interface EmailProps {
  open: boolean;
  close: () => void;
  noteData: string;
  surveyId: string;
}

function Notes(props: EmailProps) {
  const dispatch = useDispatch();
  const { open, close, noteData, surveyId } = props;
  const [notes, setNotes] = useState(noteData);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState('');
  const [toastType, setToastType] = useState<'success' | 'error'>('success');

  const save = () => {
    setLoading(true);
    dispatch(
      saveNotes({ id: surveyId, notes }, (res, message) => {
        setLoading(false);
        if (res) {
          close();
          setToastType('success');
          setToast('Notes saved successfully');
        } else {
          setToastType('error');
          setToast(message || 'Failed to save notes');
        }
      }),
    );
  };

  return (
    <>
      <Modal
        fullWidth
        open={open}
        onClose={close}
        title='Notes'
        button={<Button text='Save' onClick={save} loading={loading} />}
        data={
          <Box>
            <CKEditor
              editor={ClassicEditor}
              config={{
                toolbar: {
                  items: ['link'],
                },
                plugins: [AutoLink, Essentials, Link, Paragraph],
                initialData: notes,
                link: {
                  addTargetToExternalLinks: true,
                  defaultProtocol: 'https://',
                },
              }}
              onChange={(_, editor) => setNotes(editor.getData())}
            />
          </Box>
        }
      />
      <ToastMessage
        toast={toast}
        close={() => setToast('')}
        messageType={toastType || 'success'}
        autoHideDuration={6000}
      />
    </>
  );
}

export default Notes;
